import ReactGA from 'react-ga4';

const MEASUREMENT_ID = 'G-T3P6PPP46Q'; // remplace par ton ID

export const initGA = () => {
  ReactGA.initialize(MEASUREMENT_ID);
};

export const trackPageView = (path) => {
  ReactGA.send({ hitType: "pageview", page: path });
};
